<template>
  <div>
    <div v-show="categoryTypeSelected === '3'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/37155258808845"
            target="_blank"
          >
            支払い方法は何がありますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053098032"
            target="_blank"
          >
            クレジットカードは何が使えますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054744991"
            target="_blank"
          >
            指定された銀行口座に振込ができません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054268672"
            target="_blank"
          >
            入金しましたがメールが届きません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054744931"
            target="_blank"
          >
            請求書の発行はできますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053573431"
            target="_blank"
          >
            領収書の発行はできますか？
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054268592"
            target="_blank"
          >
            学割と先割は併用できますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054728951"
            target="_blank"
          >
            割引が適用されていません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053431951"
            target="_blank"
          >
            クレジットカード払の分割回数を変更したい
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '4'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054191051"
            target="_blank"
          >
            カリキュラムのブックマーク機能について
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360056375072"
            target="_blank"
          >
            メンターからのメッセージはどこで確認できますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054268912"
            target="_blank"
          >
            メールアドレスを変更したいです
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054288512"
            target="_blank"
          >
            学習システムにログインできません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '5'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054288512"
            target="_blank"
          >
            学習システムにログインできません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054024812"
            target="_blank"
          >
            Slackの招待メールが届かない
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054344611"
            target="_blank"
          >
            Slackからの招待メールが英語表記でわからない
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053509451"
            target="_blank"
          >
            受講後アンケートが表示されません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053048572"
            target="_blank"
          >
            メンタリングの日程がこないのですが
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053039212"
            target="_blank"
          >
            カリキュラムの誤字はどこに報告すればいいですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053516991"
            target="_blank"
          >
            さくらインターネットから請求がきましたが、なぜですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '11'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054287112"
            target="_blank"
          >
            テックアカデミーキャリアでは新卒の就職活動もサポート可能ですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053166132"
            target="_blank"
          >
            キャリアサポートと他社サービスを両方利用して転職活動をしてもいいですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053098352"
            target="_blank"
          >
            エンジニアとして転職したいがどのコースがおすすめですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054770171"
            target="_blank"
          >
            紹介される企業は東京のどの辺りですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053573751"
            target="_blank"
          >
            テックアカデミーキャリアは東京以外の求人もありますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054970131"
            target="_blank"
          >
            テックアカデミーキャリアの利用を解除したい
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053966252"
            target="_blank"
          >
            パート・アルバイトの紹介をしてもらえますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054768631"
            target="_blank"
          >
            受講修了後、期間があいたがテックアカデミーキャリアで再び仕事を紹介してほしい
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '12'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360052660552"
            target="_blank"
          >
            受講終了後もカリキュラムを見ることはできますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054267192"
            target="_blank"
          >
            各課題の模範解答がほしいです
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053114811"
            target="_blank"
          >
            カリキュラムはどのようなものを使いますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053114791"
            target="_blank"
          >
            学習の進め方について
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053114711"
            target="_blank"
          >
            オリジナルプロダクトを作ることだけに時間を使うことは可能ですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053560931"
            target="_blank"
          >
            メンタリングで使用するツールについて
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054191051"
            target="_blank"
          >
            カリキュラムのブックマーク機能について
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '14'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054270612"
            target="_blank"
          >
            仕事や学業の関係で決まった時間にメンタリングができません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054742891"
            target="_blank"
          >
            無料相談をキャンセルしたいです
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053041512"
            target="_blank"
          >
            セット受講の場合、メンタリングの順番を変えられますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053572851"
            target="_blank"
          >
            パーソナルメンターの指名や変更はできますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054925431"
            target="_blank"
          >
            メンタリングに参加できなくなりました
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053560971"
            target="_blank"
          >
            予定があってメンタリングに参加ができません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054765771"
            target="_blank"
          >
            スマートフォンからのメンタリング参加について
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053087972"
            target="_blank"
          >
            メンタリングを音声のみで実施したいのですが・・・
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053561011"
            target="_blank"
          >
            メンタリングの振り替えは可能ですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053048572"
            target="_blank"
          >
            メンタリングの日程がこないのですが
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360052966292"
            target="_blank"
          >
            メンタリング時にカメラをオフにしてもいいですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054670852"
            target="_blank"
          >
            メンタリング時に就職や業界のことも質問できますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053034172"
            target="_blank"
          >
            セット受講で片方のメンタリング回数を他のコースに配分することはできますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053970292"
            target="_blank"
          >
            追加のトータルサポートプランでは、どのようにメンターが決まりますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '15'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360052661392"
            target="_blank"
          >
            質問チャンネルで質問しましたが返信がありません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/4402385405965"
            target="_blank"
          >
            Slackの履歴が消えてしまいました
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053088212"
            target="_blank"
          >
            チャットで質問する時の書き方がわかりません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054977171"
            target="_blank"
          >
            Slackのチャットサポートのメンターは複数人いますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054024812"
            target="_blank"
          >
            Slackの招待メールが届かない
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054743911"
            target="_blank"
          >
            Slackをアップグレードしてもいいですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054727971"
            target="_blank"
          >
            Slackに参加したら英語表記になっています
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '16'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053968092"
            target="_blank"
          >
            コースに迷っています
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053572231"
            target="_blank"
          >
            どのコースが合っているかわかりません
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053098352"
            target="_blank"
          >
            エンジニアとして転職したいがどのコースがおすすめですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054744251"
            target="_blank"
          >
            追加サポートもっと早い日程に申し込めますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053561491"
            target="_blank"
          >
            追加サポートは受講が終了してから期間を空けても利用可能ですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '17'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053968092"
            target="_blank"
          >
            コースに迷っています
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054765771"
            target="_blank"
          >
            スマートフォンからのメンタリング参加について
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054742891"
            target="_blank"
          >
            無料相談をキャンセルしたいです
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '18'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360054320312"
            target="_blank"
          >
            テックアカデミーはどのようなサービスですか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360052654732"
            target="_blank"
          >
            初心者ですが問題ありませんか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360052654972"
            target="_blank"
          >
            年齢制限はありますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360052660552"
            target="_blank"
          >
            受講終了後もカリキュラムを見ることはできますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053114671"
            target="_blank"
          >
            Windows、MacなどPCの指定はありますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
        <li class="mb-2">
          <a
            href="https://support.techacademy.jp/hc/ja/articles/360053239792"
            target="_blank"
          >
            修了証は発行されますか
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
    <div v-show="categoryTypeSelected === '19'">
      <p class="my-4 font-bold">
        関連するFAQ
      </p>
      <ul class="mx-5 my-2 list-outside list-disc p-0">
        <li>
          <a
            href="https://support.techacademy.jp/hc/ja/articles/4427163201677"
            target="_blank"
          >
            キャンペーンは重複で適用されますか？
            <FontAwesomeIcon
              :icon="faArrowUpRightFromSquare"
              class="fa-fw inline size-4 pl-1"
            />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowUpRightFromSquare } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faArrowUpRightFromSquare,
    }
  },
  props: {
    categoryTypeSelected: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  }
}

export default defineNuxtComponent(options)
</script>
